// src/shared/hooks/useApiMutation.ts

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiRequest } from '@/services/api/api';
import { ApiRequestOptions } from '@/services/api/api.types';

export function useApiMutation<T, P>(
  method: 'get' | 'post' | 'patch' | 'put' | 'delete',
  url: string,
  auth = false,
  requestOptions?: ApiRequestOptions<P>, // Optional request options
  options?: UseMutationOptions<T, unknown, P>,
) {
  return useMutation<T, unknown, P>({
    mutationFn: async (data: P) => {
      const response = await apiRequest<T, P>(
        method,
        url,
        data,
        auth,
        requestOptions,
      );
      return response.data;
    },
    ...options,
  });
}
